import React from 'react';
import { TWILIGHT_NAVY, alpha } from '../../theme/colors';
import { T } from '../../theme/typography';

const VARIANT_TYPOGRAPHY = {
  body: T.BODY,
  data: T.DATA,
  dataValue: T.DATA_VALUE,
  eyebrow: T.EYEBROW,
  whisper: T.WHISPER,
};

/**
 * Shared Label primitive — deliberately thin. Its whole job is the
 * color/opacity decision: `muted` replaces the app-wide
 * `color: TWILIGHT_NAVY, opacity: 0.5` idiom (which composites to ~3.0:1,
 * below the 4.5:1 floor) with `alpha('navy', 0.7)` (~5.3:1) — one flip,
 * fixing the single most-repeated contrast failure in the codebase.
 *
 * Does not own font-size — that varies too much per call site
 * (T.DATA with a one-off fontSize override is common) to parameterize
 * without bloating this API for no accessibility benefit. Use the `style`
 * prop for size overrides same as before.
 */
const Label = ({
  muted = false,
  variant = 'body',
  tone,
  as: Tag = 'span',
  children,
  style,
  ...rest
}) => {
  const typography = VARIANT_TYPOGRAPHY[variant] || T.BODY;
  const color = tone || (muted ? alpha('navy', 0.7) : TWILIGHT_NAVY);

  return (
    <Tag
      style={{
        ...typography,
        color,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Label;
